import api from "./api";

class CfgAPI {

  async getFornecedores(headers){

    const response = await api.get("/getFornecedores", {headers});
    return response;
  }

  async getCompradores(headers){

    const response = await api.get("/getCompradores", {headers});
    return response;
  }

  async addFornecedor(headers, params){
    const response = await api({
      method: 'post',
      url: '/addFornecedor',
      headers,
      data:params
    });
    return response;
  }

  async addComprador(headers, params){
    const response = await api({
      method: 'post',
      url: '/addComprador',
      headers,
      data:params
    });
    return response;
  }


  async delComprador(headers, params){
    const response = await api({
      method: 'delete',
      url: '/delComprador',
      headers,
      data:params
    });
    return response;
  }


  //  funcoes de empresa

  async getEmpresas(headers){

    const response = await api.get("/getEmpresas", {headers});
    return response;
  }

  async addEmpresa(headers, params){
    const response = await api({
      method: 'post',
      url: '/addEmpresa',
      headers,
      data:params
    });
    return response;
  }

  async delEmpresa(headers, params){
    const response = await api({
      method: 'delete',
      url: '/delEmpresa',
      headers,
      data:params
    });
    return response;
  }

  // funcoes de grupos

  async getGrupos(headers){

    const response = await api.get("/getGrupos", {headers});
    return response;
  }

  async addGrupo(headers, params){
    const response = await api({
      method: 'post',
      url: '/addGrupo',
      headers,
      data:params
    });
    return response;
  }

  async delGrupo(headers, params){
    const response = await api({
      method: 'delete',
      url: '/delGrupo',
      headers,
      data:params
    });
    return response;
  }

  //funcoes de grupo e filial

  async getGrupoFilial(headers){

    const response = await api.get("/getGrupoFilial", {headers});
    return response;
  }

  async getFilial(headers){

    const response = await api.get("/getFilial", {headers});
    return response;
  }

  async addGrupoFilial(headers, params){
    const response = await api({
      method: 'post',
      url: '/addGrupoFilial',
      headers,
      data:params
    });
    return response;
  }

  async delGrupoFilial(headers, params){
    const response = await api({
      method: 'delete',
      url: '/delGrupoFilial',
      headers,
      data:params
    });
    return response;
  }

  

}

export default new CfgAPI();